import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  COMPLETED_IMMUNISATIONS_PATH,
  IMMUNISATION_RECORDS_PATH,
  MISSED_IMMUNISATION_PATH,
  MORE_ABOUT_IMMUNISATION_PATH,
  NATIONALLY_RECOMMENDED_PATH,
  UPCOMING_IMMUNISATION_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const ImmunisationPage = lazy(() => import('@features/HealthRecords/Immunisation/pages/ImmunisationsPage'));
const MoreAboutImmunisationPage = lazy(
  () => import('@features/HealthRecords/Immunisation/pages/MoreAboutImmunisation')
);
const CompletedImmunisationsPage = lazy(
  () => import('@features/HealthRecords/Immunisation/pages/CompletedImmunisationsPage')
);
const NationallyRecommendedPage = lazy(
  () => import('@features/HealthRecords/Immunisation/pages/NationallyRecommended')
);
const MissedImmunisationsPage = lazy(
  () => import('@features/HealthRecords/Immunisation/pages/MissedImmunisationsPage')
);
const UpcomingImmunisationsPage = lazy(
  () => import('@features/HealthRecords/Immunisation/pages/UpcomingImmunisationsPage')
);

export const IMMUNISATION_ROUTES: RouteConfig[] = [
  // IMMUNISATION_RECORDS
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <ImmunisationPage />,
    displayTitle: () => 'Immunisation Records',
    pageType: PageType.PRIVATE,
    path: IMMUNISATION_RECORDS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.immunisationRecords,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <MoreAboutImmunisationPage />,
    displayTitle: () => 'More About Immunisation',
    pageType: PageType.PRIVATE,
    path: MORE_ABOUT_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.immunisationRecords,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CompletedImmunisationsPage />,
    displayTitle: () => 'Completed Immunisations',
    pageType: PageType.PRIVATE,
    path: COMPLETED_IMMUNISATIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.immunisationRecords,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <NationallyRecommendedPage />,
    displayTitle: () => 'Nationally Recommended (NAIS/ NCIS)',
    pageType: PageType.PRIVATE,
    path: NATIONALLY_RECOMMENDED_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.immunisationRecords,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <UpcomingImmunisationsPage />,
    displayTitle: () => 'Upcoming Immunisation',
    pageType: PageType.PRIVATE,
    path: UPCOMING_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.immunisationRecords,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <MissedImmunisationsPage />,
    displayTitle: () => 'Missed Immunisation',
    pageType: PageType.PRIVATE,
    path: MISSED_IMMUNISATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.immunisationRecords,
  },
];
